import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, PlusSquare, List, Library, Settings } from 'lucide-react';

const adminPath = process.env.REACT_APP_ADMIN_PATH || '/sh-yonetim-kapisi-x7';

const navItems = [
  { to: '/dashboard', icon: <LayoutDashboard size={20} />, label: 'Dashboard' },
  { to: '/add-content', icon: <PlusSquare size={20} />, label: 'İçerik Ekle' },
  { to: '/all-content', icon: <List size={20} />, label: 'Tüm İçerikler' },
  { to: '/media', icon: <Library size={20} />, label: 'Medya' },
  { to: '/settings', icon: <Settings size={20} />, label: 'Ayarlar' },
];

const Sidebar: React.FC = () => {
  return (
    <aside className="w-64 bg-blue-900/50 p-6 flex flex-col">
      <div className="text-center mb-10">
        <h1 className="text-2xl font-bold text-white">Say-Hot</h1>
        <span className="text-xs text-blue-300">Sky Command</span>
      </div>
      <nav className="flex flex-col space-y-2">
        {navItems.map((item) => (
          <NavLink
            key={item.label}
            to={`${adminPath}${item.to}`}
            className={({ isActive }) =>
              `flex items-center px-4 py-3 rounded-lg transition-colors duration-200 ${
                isActive
                  ? 'bg-blue-700 text-white'
                  : 'text-blue-200 hover:bg-blue-800 hover:text-white'
              }`
            }
          >
            {item.icon}
            <span className="ml-4 font-medium">{item.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="mt-auto">
        {/* Potentially user profile/logout button here */}
      </div>
    </aside>
  );
};

export default Sidebar;
